import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const SideSection = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  position: "relative",
}));

export enum SideSectionButtonBorderOptions {
  LEFT = "left",
  RIGHT = "right",
}
interface SideSectionButtonProps {
  border: SideSectionButtonBorderOptions;
}

const sideSectionButtonBorder = `1px solid ${colors.gray200}`;

export const SideSectionButton = styled("div")(({ border }: SideSectionButtonProps) => ({
  display: "flex",
  height: "24px",
  padding: "2px",
  alignItems: "center",
  gap: "10px",
  width: "16px",
  position: "absolute",
  top: "0px",
  zIndex: 50,

  cursor: "pointer",
  backgroundColor: colors.gray100,

  ...(border === SideSectionButtonBorderOptions.LEFT
    ? { borderLeft: sideSectionButtonBorder, left: "-16px", borderBottomLeftRadius: "4px" }
    : { borderRight: sideSectionButtonBorder, right: "-16px", borderBottomRightRadius: "4px" }),
  borderBottom: sideSectionButtonBorder,
}));
